import Vessel    from './plugins/vessel'
import ElementUI from './plugins/element-ui'

import * as Components from './components'
import * as Directives from './directives'

const Plugin = {
  install(Vue, options) {
    Vue.use(ElementUI, options)
    Vue.use(Vessel)

    Object.values(Components).forEach(Component => {
      Vue.use(Component)
    })

    Object.values(Directives).forEach(Directive => {
      Vue.use(Directive)
    })
  }
}

export default Plugin
